import { useEffect, useState } from "react";
import Sidebar from "../components/Sidebar";
import Header from "../components/Header";

export default function Withdrawals() {

  const token = localStorage.getItem("adminToken");

  const [withdrawals, setWithdrawals] = useState([]);

  useEffect(() => {
    loadWithdrawals();
  }, []);

  async function loadWithdrawals() {

    try {

      const res = await fetch("/api/admin/withdrawals", {

        headers: {
          Authorization: "Bearer " + token
        }

      });

      const json = await res.json();

      setWithdrawals(json);

    } catch (err) {

      console.log(err);

    }

  }

  return (

    <div
      style={{
        display: "flex",
        background: "#f3f4f6",
        minHeight: "100vh"
      }}
    >

      <Sidebar />

      <div
        style={{
          flex: 1
        }}
      >

        <Header />

        <div
          style={{
            padding: 25
          }}
        >

          <h2>Withdrawal History</h2>

          <table
            width="100%"
            cellPadding="10"
            style={{
              background: "#fff",
              borderCollapse: "collapse"
            }}
          >

            <thead>

              <tr
                style={{
                  background: "#2563eb",
                  color: "#fff"
                }}
              >

                <th>User ID</th>

                <th>Amount</th>

                <th>Wallet Address</th>

                <th>Status</th>

                <th>Date</th>

              </tr>

            </thead>

            <tbody>

              {

                withdrawals.map((item) => (

                  <tr key={item._id}>

                    <td>{item.userId}</td>

                    <td>

                      {Number(
                        item.amount || 0
                      ).toFixed(2)} USDT

                    </td>

                    <td
                      style={{
                        maxWidth: 300,
                        wordBreak: "break-all"
                      }}
                    >
                      {item.walletAddress || "-"}
                    </td>

                    <td>

                      <span
                        style={{
                          color:
                            item.status === "Approved"
                              ? "green"
                              : item.status === "Rejected"
                              ? "red"
                              : "orange",
                          fontWeight: "bold"
                        }}
                      >
                        {item.status}
                      </span>

                    </td>

                    <td>

                      {new Date(
                        item.createdAt
                      ).toLocaleString()}

                    </td>

                  </tr>

                ))

              }

            </tbody>

          </table>

        </div>

      </div>

    </div>

  );

}
